module.exports = __webpack_public_path__ + "8c70d09bf9b1d42a6d94d311c7aa1033.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-4.png
// module id = 3091
// module chunks = 0